import { identity } from "~/tools/identity";
import { isShallowEqual } from "~/tools/is-shallow-equal";
import { sortBy } from "~/tools/sort-by";
import { toArray } from "~/tools/to-array";

/**
 * Compares two sets or arrays of primitive values (string, number, boolean).
 * If it compares arrays it ignores the order of elements.
 *
 * @param left a ReadonlySet or ReadonlyArray of values
 * @param right a ReadonlySet or ReadonlyArray of values
 * @returns true if the sets are different, false otherwise
 */
export function isSetDirty<TValue extends string | number | boolean>(
	left: ReadonlySet<TValue> | ArrayLike<TValue>,
	right: ReadonlySet<TValue> | ArrayLike<TValue>,
): boolean {
	const leftArr = toArray(left);
	const rightArr = toArray(right);

	if (leftArr.length !== rightArr.length) {
		return true;
	}

	return !isShallowEqual(sortBy(leftArr, identity), sortBy(rightArr, identity));
}
